import DataServiceSQL from "../DataService/DataServiceSQL";

//Function to convert FHIR admin user
const convert_fhir_user_admin = (users_list) => {
  let ret = ""
  if(users_list && users_list.entry && users_list.entry.length !== 0) {
    users_list.data = users_list.entry[0]
    users_list.data.firstName = users_list.entry[0].name[0].given[0]
    users_list.data.lastName = users_list.entry[0].name[0].family
    users_list.data.email = users_list.entry[0].telecom.value
    return(users_list.data);
  }
  return ret
}

//Function to convert FHIR staff user
const convert_fhir_user_staff = (users_list) => {
  let ret = []
  if(!users_list || !users_list.entry) return ret
  users_list.entry.forEach(user => {
    // Practitioners are created with role "admin" (Components/Staff/AddStaff.js),
    // so filtering on "staff" alone hid every one of them from the staff list —
    // and with them the practitioner badge of StaffList.rowIsPractitioner.
    // profession is the marker AddStaff and the seed write on table_user; it is
    // specific: PSAD members carry "psad" and plain admins carry null, so
    // neither enters the list.
    if (user.role === "staff" || user.profession === "practitioner") {
      let new_staff = {
        FK_structure: user.FK_structure,
        anonymised_patient: user.anonymised_patient,
        email: user.telecom.value,
        id_user: user.identifier.value,
        rpps: user.rpps || null,
        profession: user.profession || null,
        category: user.category || null,
      }
      ret.push(new_staff)
    }
  })
  return ret
}

//Function to retrieve one staff users by username
const get_staff_user_by_username = async (username) => {
    return await DataServiceSQL.findAllStaffUsersByStructureReq_fhir(username)
      .then((response) => {
        let ret = response
        ret.data = convert_fhir_user_staff(response.data);
        return(response);
      })
      .catch((e) => {
        console.log(e);
      });
};

//Function to retrieve SQL staff users list
const get_staff_user_list = async () => {
    return await DataServiceSQL.getUserAccountReq_fhir()
      .then((response) => {
        return(convert_fhir_user_staff(response.data));
      })
      .catch((e) => {
        console.log(e);
      });
};


//Function to retrieve SQL user list
const get_User_Account = async (practitioner_id) => {
  return await DataServiceSQL.getUserAccountReq_fhir()
    .then((response) => {
      return(response.data);
    })
    .catch((e) => {
      console.log(e);
    });
};


//Const to import functions in other files
const UserFunctionsGetter = {
  get_User_Account,
  get_staff_user_list,
  get_staff_user_by_username,
  convert_fhir_user_admin,
  convert_fhir_user_staff
};

export default UserFunctionsGetter;